import {environment} from 'src/environments/environment';
import {ImageTypeEnum} from '../graphql/globalTypes';
import {TemplateService_GetTemplateItem_templateItem} from '../services/__generated__/TemplateService_GetTemplateItem';

const extensionMap: {[key in ImageTypeEnum]: string} = {
  [ImageTypeEnum.GIF]: '.gif',
  [ImageTypeEnum.Video]: '.mp4',
  [ImageTypeEnum.Image]: '.png',
};

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function notNull<TValue>(value: TValue | null | undefined): TValue {
  if (value === null || value === undefined) {
    throw new Error('Unexpected null');
  }
  return value;
}

export function getUrl(
  templateItem: TemplateService_GetTemplateItem_templateItem,
  mode: 'create' | 'instant',
): string {
  if (mode === 'create') {
    return `${environment.createHost}${templateItem.lookupId}`;
  }

  // Include all parameters if none are set as visible. (This is most likely a template without a builderConfigId.)
  const visibleFields: string[] = [];
  if (templateItem.builderVisibleFields.length === 0) {
    const params = templateItem.parameters.edges.map(e => e.node);
    params.forEach(param => {
      visibleFields.push(param.name);
    });
  } else {
    templateItem.builderVisibleFields.forEach(field => {
      if (field !== null) {
        visibleFields.push(field);
      }
    });
  }

  const unlockedFields = templateItem.parameters.edges
    .map(e => e.node)
    .filter(pm => pm.locked === false);
  const queryParams = new URLSearchParams({});
  const mediaType = templateItem.type?.toLowerCase();
  const extension = templateItem.type !== null ? extensionMap[templateItem.type] : '.png';

  unlockedFields.forEach(param => {
    if (visibleFields.includes(param.name)) {
      queryParams.append(param.name, param.defaultValue);
    }
  });

  return `${environment.instantHost}${mediaType}/${templateItem.lookupId}${extension}${
    queryParams.toString().length > 0 ? '?' + queryParams.toString() : ''
  }`;
}

export function createRandomString(length: number): string {
  let result = '';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
